// runtime-config.js
// Utility-Funktion zum Abrufen der Runtime-Umgebungsvariablen

export const getRuntimeConfig = () => {
  // Fallback auf import.meta.env, falls window.env nicht verfügbar ist
  return {
    ENV: window.env?.ENV || import.meta.env.VITE_ENV,
    GRAPHQL_ENDPOINT: window.env?.GRAPHQL_ENDPOINT || import.meta.env.VITE_GRAPHQL_ENDPOINT,
    REDIRECT_URI: window.env?.REDIRECT_URI || import.meta.env.VITE_REDIRECT_URI,
    MSAL_CLIENTID: window.env?.MSAL_CLIENTID || import.meta.env.VITE_MSAL_CLIENTID,
    API_APPLICATION_ID_URI: window.env?.API_APPLICATION_ID_URI || import.meta.env.VITE_API_APPLICATION_ID_URI,
    AZ_MAPS_CLIENTID: window.env?.AZ_MAPS_CLIENTID || import.meta.env.VITE_AZ_MAPS_CLIENTID,
    MSAL_AUTHORITY_URL: window.env?.MSAL_AUTHORITY_URL || import.meta.env.VITE_MSAL_AUTHORITY_URL,
    APPLICATIONINSIGHTS_CONNECTION_STRING: window.env?.APPLICATIONINSIGHTS_CONNECTION_STRING || import.meta.env.VITE_CONNECTING_STRING,
  };
};

// Beispiel für die Verwendung:
// import { getRuntimeConfig } from './runtime-config';
// const config = getRuntimeConfig();
// console.log('GraphQL Endpoint:', config.GRAPHQL_ENDPOINT);